<div [ngClass]="getClasses()" (click)="whenClicked($event)"></div>